// client/src/App.js

import {
  AlertDialog,
  AlertDialogBody, AlertDialogContent, AlertDialogFooter,
  AlertDialogHeader, AlertDialogOverlay,
  Box,
  Button,
  Center,
  Flex,
  FormControl,
  HStack,
  IconButton,
  Input,
  List,
  ListItem,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  NumberDecrementStepper,
  NumberIncrementStepper,
  NumberInput,
  NumberInputField,
  NumberInputStepper,
  Select,
  Stack,
  Table,
  TableContainer,
  Tbody,
  Td,
  Text,
  Textarea,
  Tfoot,
  Th,
  Thead,
  Tr,
  useToast
} from '@chakra-ui/react';
import React, { useEffect, useState } from 'react';
import { AiFillStepBackward, AiFillStepForward } from "react-icons/ai";
import { FaCopy, FaSortDown, FaSortUp } from "react-icons/fa";
import { IoClose } from "react-icons/io5";
import { MdAdd, MdDelete, MdEdit } from "react-icons/md";
import { useNavigate } from 'react-router-dom';
import "../../App.css";
import CommonContext from '../../commonContext';
import { postCall } from '../../utils/requests';
import Utils from '../../utils/utils';

function TrainingSheets() {

  /* TODO const navigate = useNavigate(); */
  const commonContext = React.useContext(CommonContext);
  const navigate = useNavigate();

  const logout = () => {
    console.log("logout")
    localStorage.removeItem("accessToken");
    /* TODO navigate('/'); */
  }

  /* utils */
  const toast = useToast();
  const fileRef = React.useRef(null);

  /* table */
  const [tableContent, setTableContent] = useState([]);
  const [allData, setAllData] = useState([]);

  /* delete form */
  const [isOpenDelete, setIsOpenDelete] = React.useState(false)
  const [isOpenCreate, setIsOpenCreate] = React.useState(false)
  const [isOpenEdit, setIsOpenEdit] = React.useState(false)
  const [idToDelete, setIdToDelete] = React.useState(null)
  const [idToUpdate, setIdToUpdate] = React.useState(null)
  const [nameToDelete, setNameToDelete] = React.useState("")
  const [categoryName, setCategoryName] = React.useState("")
  const [page, setPage] = React.useState(1)
  const [search, setSearch] = React.useState("")
  const [searchFather, setSearchFather] = React.useState("")
  const [advices, setAdvices] = React.useState(false)
  const [trainWithMe, setTrainWithMe] = React.useState(false)
  const [inHome, setInHome] = React.useState(false)
  const [idFather, setIdFather] = React.useState("0")
  const [fathers, setFathers] = React.useState([])
  const [defaultFather, setDefaultFather] = React.useState(0)
  const [sortOrder, setSortOrder] = React.useState("desc")
  const [sortedBy, setSortedBy] = React.useState("")
  const [allexercises, setAllexercises] = React.useState([])
  const [trainings, setTrainings] = React.useState([
    {
      name: "",
      description: "",
      duration: "",
      zone: "",
      repeatitions: 1,
      um: "minutes"
    }
  ])

  const [isPrebuiltModalOpen, setIsPrebuiltModalOpen] = useState(false);

  const handleOpenPrebuiltModal = () => setIsPrebuiltModalOpen(true);
  const handleClosePrebuiltModal = () => setIsPrebuiltModalOpen(false);
  const handleSelectExercise = (exercise) => {

    setTrainings([...trainings, {
      name: exercise.name,
      description: exercise.description,
      duration: exercise.duration,
      zone: exercise.zone,
      repeatitions: exercise.repeatitions,
      um: exercise.um
    }]);


    handleClosePrebuiltModal();
  };


  const fetchExercises = async () => {


    postCall("/fetchTrainingSheets", {}).then((data) => {
      console.log("data", data)


      setAllData(Array.from(data.data.map((item) => {


        return {
          id: item.id_training_sheet,
          name: item.name,
          events: item.events,
          created_at: Utils.convertDateToIta(item.created_on, false),
          creation_date: item.created_on,

        }
      })));



      /* put in tableContent only first n element from allData */
      setTableContent(Array.from(data.data.map((item) => {


        return {
          id: item.id_training_sheet,
          name: item.name,
          events: item.events,
          created_at: Utils.convertDateToIta(item.created_on, false),
          creation_date: item.created_on,

        }
      })).slice((page * 7) - 7, (page * 7)));

    });

    postCall("/fetchAllExercises", {}).then((data) => {

      setAllexercises(data.data)

    });

  }



  useEffect(() => {

    fetchExercises()

    commonContext.setCurrentPath("Schede allenamenti")
    commonContext.setCurrentPage("trainingsheets")

  }, []);






  /* BEGIN - EDIT FORM */

  const handleSubmitEdit = async (event) => {
    event.preventDefault();
    if (categoryName === "") {
      toast({
        title: "Errore",
        description: "Inserisci un nome per l'allenamento",
        status: "error",
        duration: 2000,
        isClosable: true,
        position: "top"
      })
      return
    }

    postCall("/updateTraining", {
      name: categoryName,
      id_training_set: idToUpdate,
      trainings: trainings,
    }).then((data) => {
      if (data.status === "success") {

        fetchExercises()
        setCategoryName("")

        toast({
          title: "Perfetto",
          description: "Allenamento modificato",
          status: "success",
          duration: 2000,
          isClosable: true,
          position: "top"
        })
        onCloseEdit()

      } else {

        toast({
          title: "Errore",
          description: data.error === "15" ? "Questo nome esiste già" : "Si è verificato un errore",
          status: "error",
          duration: 2000,
          isClosable: true,
          position: "top"
        })
      }

    });

  }

  const onCloseEdit = async () => {
    setIsOpenEdit(false)
  }

  const openEdit = async (id, name, trainings) => {
    console.log("openEdit")
    setIdToUpdate(id);
    setCategoryName(name)
    setTrainings(trainings)

    setIsOpenEdit(true)
  }
  /* END - EDIT FORM */


  /* BEGIN - CREATE FORM */

  const handleSubmit = async (event) => {
    event.preventDefault();



    /*  if (categoryName === "" || categoryName === null || categoryName === undefined) {
       toast({
         title: "Errore",
         description: "Inserisci un nome per l'allenamento",
         status: "error",
         duration: 2000,
         isClosable: true,
         position: "top"
       })
       return
     } */

    postCall("/createTraining", {
      name: categoryName,
      trainings: trainings
    }).then((data) => {
      if (data.status === "success") {

        fetchExercises()
        setCategoryName("")
        setTrainings([])

        toast({
          title: "Perfetto",
          description: "Esercizio creato",
          status: "success",
          duration: 2000,
          isClosable: true,
          position: "top"
        })

        onCloseCreate()

      } else {

        toast({
          title: "Errore",
          description: data.error === "15" ? "Questo nome esiste già" : "Si è verificato un errore",
          status: "error",
          duration: 2000,
          isClosable: true,
          position: "top"
        })
      }

    });

  }

  const onCloseCreate = async () => {
    setIsOpenCreate(false)
  }

  const openCreate = async (id, name) => {

    console.log(allexercises)

    setTrainings([
      {
        name: "",
        description: "",
        duration: "",
        zone: "",
        repeatitions: 1,
        um: "minutes"
      }
    ])
    setCategoryName("")
    setIsOpenCreate(true)



  }

  const openCopy = async (name, trainings) => {
    setCategoryName(name)
    setTrainings(trainings)
    setIsOpenCreate(true)
  }
  /* END - CREATE FORM */


  /* BEGIN - DELETE FORM */
  const deleteSheet = async () => {
    console.log("onCloseDelete")


    setIsOpenDelete(false)
    postCall("/deleteTrainingSheet", {
      id_training_sheet: idToDelete
    }).then((data) => {
      if (data.status === "success") {

        /* remove the deleted category from the list */
        setTableContent(tableContent.filter((item) => item.id !== idToDelete))
        setIdToDelete(null)
        setNameToDelete("")

        toast({
          title: "Perfetto",
          description: "Scheda eliminata",
          status: "success",
          duration: 2000,
          isClosable: true,
          position: "top"
        })
        fetchExercises()
      } else {
        toast({
          title: "Errore",
          description: "Si è verificato un errore",
          status: "error",
          duration: 2000,
          isClosable: true,
          position: "top"
        })
      }

    });
  }

  const onCloseDelete = async () => {
    setIsOpenDelete(false)
  }

  const openDelete = async (id, name) => {
    console.log("openDelete")
    setIdToDelete(id)
    setNameToDelete(name)
    setIsOpenDelete(true)
  }
  /* END - DELETE FORM */

  /* BEGIN - SORTABLE */

 

  const handleSortCreated = () => {
    setSortedBy("created")

    let allDataSorted = []

    if (sortOrder === 'asc') {
      // Sort in ascending order
      allDataSorted = [...allData].sort((a, b) => a.creation_date.localeCompare(b.creation_date))
      setAllData(allDataSorted);

      setSortOrder('desc');
    } else {
      // Sort in descending order
      allDataSorted = [...allData].sort((a, b) => b.creation_date.localeCompare(a.creation_date));
      setAllData(allDataSorted);

      setSortOrder('asc');
    }

    setTableContent(Array.from(allDataSorted.map((item) => {

      return {
        id: item.id,
        name: item.name,
        events: item.events,
        created_at: item.created_at,
        creation_date: item.created_on,

      }
    })).slice((page * 7) - 7, (page * 7)));
  };

  const handleSortName = () => {
    setSortedBy("name")

    let allDataSorted = []

    if (sortOrder === 'asc') {
      // Sort in ascending order
      allDataSorted = [...allData].sort((a, b) => a.name.localeCompare(b.name))
      setAllData(allDataSorted);

      setSortOrder('desc');
    } else {
      // Sort in descending order
      allDataSorted = [...allData].sort((a, b) => b.name.localeCompare(a.name));
      setAllData(allDataSorted);

      setSortOrder('asc');
    }

    setTableContent(Array.from(allDataSorted.map((item) => {

      return {
        id: item.id,
        name: item.name,
        events: item.events,
        created_at: item.created_at,
        creation_date: item.created_on,


      }
    })).slice((page * 7) - 7, (page * 7)));
  };

  /* END - SORTABLE */



  return (
    <div style={{ "width": "100%", textAlign: "center", height: "100%", overflowY: "scroll" }}>


      <Modal isOpen={isPrebuiltModalOpen} onClose={handleClosePrebuiltModal}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Seleziona un Esercizio</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <List spacing={3} maxH="500px"
              overflowY="auto"
            >
              {allexercises.map((exercise, index) => (
                <ListItem
                  p="5px"
                  rounded="md"
                  key={index}
                  cursor="pointer"
                  _hover={{ backgroundColor: 'gray.200' }}
                  onClick={() => handleSelectExercise(exercise)}

                >
                  {exercise.name}
                </ListItem>
              ))}
            </List>
          </ModalBody>
          <ModalFooter>
            <Button variant="ghost" onClick={handleClosePrebuiltModal}>Chiudi</Button>
          </ModalFooter>
        </ModalContent>
      </Modal>



      {/* BEGIN - FORM TO EDIT A NEW CATEGORY */}
      <Modal isOpen={isOpenEdit} onClose={onCloseEdit}>
        <ModalOverlay />
        <ModalContent
          minWidth="80%"
        >
          <ModalHeader>Modifica allenamento</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <form onSubmit={handleSubmit}>
              <FormControl id="categoryName">
                <Input
                  placeholder='Nome allenamento'
                  mb="20px"
                  type="text"
                  value={categoryName}
                  onChange={(event) => setCategoryName(event.target.value)}
                />


                {trainings.map((training, index) =>

                  <Box
                    borderWidth="3px"
                    borderColor="gray.400"
                    borderRadius="md"
                    p="5"
                    mb="20px"
                  >
                    <HStack
                      /* alignItems="center" */
                      justifyContent="space-between"
                      w="full"
                    >

                      <Box
                        fontSize="xl"
                        fontWeight="bold"
                        mb="10px"
                        bg="green.200"
                        w="30px"
                        h="30px"
                        borderRadius="50%"
                      >
                        <Center>
                          {index + 1}
                        </Center>
                      </Box>


                      <Center>
                        <Button
                          bg="red.500"
                          onClick={() => setTrainings([...trainings.slice(0, index), ...trainings.slice(index + 1)])}
                          p="5px"
                        >
                          <IoClose color="white" size="20px" />
                        </Button>

                      </Center>


                    </HStack>


                    <Flex
                      mt="10px"
                      alignItems="top"
                    >
                      <Input
                        type="text"
                        value={trainings[index].name}
                        onChange={(event) => setTrainings([...trainings.slice(0, index), { ...trainings[index], name: event.target.value }, ...trainings.slice(index + 1)])}
                        placeholder="Nome esercizio"
                        w="50%"
                        mr="20px"
                        onBlur={() => {
                          for (let i = 0; i < allexercises.length; i++) {
                            if (allexercises[i].name.toLowerCase().replaceAll(" ", "") === trainings[index].name.toLowerCase().replaceAll(" ", "")) {
                              setTrainings([...trainings.slice(0, index), { ...trainings[index], description: allexercises[i].description, duration: allexercises[i].duration, zone: allexercises[i].zone, repeatitions: allexercises[i].repeatitions, um: allexercises[i].um }, ...trainings.slice(index + 1)])
                              break;
                            }
                          }
                        }}
                        onKeyDown={
                          (e) => {
                            console.log("okok")

                            if (e.key === "Enter") {
                              for (let i = 0; i < allexercises.length; i++) {
                                if (allexercises[i].name.toLowerCase().replaceAll(" ", "") === trainings[index].name.toLowerCase().replaceAll(" ", "")) {
                                  setTrainings([...trainings.slice(0, index), { ...trainings[index], description: allexercises[i].description, duration: allexercises[i].duration, zone: allexercises[i].zone, repeatitions: allexercises[i].repeatitions, um: allexercises[i].um }, ...trainings.slice(index + 1)])
                                  break;
                                }
                              }

                            }
                          }
                        }
                      >
                      </Input>
                      <Textarea
                        type="text"
                        value={trainings[index].description}
                        onChange={(event) => setTrainings([...trainings.slice(0, index), { ...trainings[index], description: event.target.value }, ...trainings.slice(index + 1)])}
                        placeholder="Descrizione"
                        w="50%"
                        mr="20px"
                        rows={1}
                      >
                      </Textarea>





                    </Flex>

                    <Flex
                      mt="20px" Pforma
                      alignItems="center"

                    >
                      <Box mr="10px" ml="10px">
                        Tempo/distanza esercizio:
                      </Box>
                      <Input
                        type="text" //time?
                        value={trainings[index].duration}
                        onChange={(event) => setTrainings([...trainings.slice(0, index), { ...trainings[index], duration: event.target.value }, ...trainings.slice(index + 1)])}
                        w="300px"
                      >
                      </Input>
                      <Select
                        ml="20px"
                        w="200px"
                        value={trainings[index].um}
                        onChange={(event) => setTrainings([...trainings.slice(0, index), { ...trainings[index], um: event.target.value }, ...trainings.slice(index + 1)])} placeholder='Unità di misura'>
                        <option key="minutes" value="minutes">Minuti</option>
                        <option key="meters" value="meters">Metri</option>
                        <option key="meters" value="meters">Chilometri</option>

                      </Select>
                      <Select
                        ml="20px"
                        w="400px"
                        value={trainings[index].zone}
                        onChange={(event) => setTrainings([...trainings.slice(0, index), { ...trainings[index], zone: event.target.value }, ...trainings.slice(index + 1)])} placeholder='Seleziona una zona'>
                        <option key="z1" value="z1">Z1 - Recupero</option>
                        <option key="z2" value="z2">Z2 - Fondo lento</option>
                        <option key="z3" value="z3">Z3 - Fondo medio</option>
                        <option key="z4" value="z4">Z4 - Soglia</option>
                        <option key="z5" value="z5">Z5 - Vo2Max</option>
                        <option key="z6" value="z6">Z6 - Capacità anaerobica</option>
                        <option key="z7" value="z7">Z7 - Sprint</option>


                      </Select>

                    </Flex>
                    <Flex
                      mt="20px" Pforma
                      alignItems="center"

                    >
                      <Box mr="10px" ml="10px">
                        Tempo/distanza recupero:
                      </Box>
                      <Input
                        type="text" //time?
                        value={trainings[index].recovery}
                        onChange={(event) => setTrainings([...trainings.slice(0, index), { ...trainings[index], recovery: event.target.value }, ...trainings.slice(index + 1)])}
                        w="300px"
                      >
                      </Input>
                      <Select
                        ml="20px"
                        w="200px"
                        value={trainings[index].recovery_um}
                        onChange={(event) => setTrainings([...trainings.slice(0, index), { ...trainings[index], recovery_um: event.target.value }, ...trainings.slice(index + 1)])} placeholder='Unità di misura'>
                        <option key="minutes" value="minutes">Minuti</option>
                        <option key="meters" value="meters">Metri</option>
                        <option key="meters" value="meters">Chilometri</option>

                      </Select>
                      <Select
                        ml="20px"
                        w="400px"
                        value={trainings[index].recovery_zone}
                        onChange={(event) => setTrainings([...trainings.slice(0, index), { ...trainings[index], recovery_zone: event.target.value }, ...trainings.slice(index + 1)])} placeholder='Seleziona una zona'>
                        <option key="z1" value="z1">Z1 - Recupero</option>
                        <option key="z2" value="z2">Z2 - Fondo lento</option>
                        <option key="z3" value="z3">Z3 - Fondo medio</option>
                        <option key="z4" value="z4">Z4 - Soglia</option>
                        <option key="z5" value="z5">Z5 - Vo2Max</option>
                        <option key="z6" value="z6">Z6 - Capacità anaerobica</option>
                        <option key="z7" value="z7">Z7 - Sprint</option>


                      </Select>

                    </Flex>

                    <Flex
                      alignItems={"center"}
                      mt="20px"
                    >
                      <Box mr="10px" ml="10px">
                        Ripetizione/i:
                      </Box>

                      <NumberInput
                        w="100px"
                        min={1}
                        max={99}
                        defaultValue={1}
                        value={trainings[index].repeatitions}
                        onChange={(valueString, valueNumber) => {
                          setTrainings([...trainings.slice(0, index), { ...trainings[index], repeatitions: valueString ?? 1 }, ...trainings.slice(index + 1)])
                        }}
                      >
                        <NumberInputField />
                        <NumberInputStepper>
                          <NumberIncrementStepper />
                          <NumberDecrementStepper />
                        </NumberInputStepper>
                      </NumberInput>

                    </Flex>

                  </Box>
                )}

                <Button
                  mt="20px"
                  mr="20px"
                  bg="gray.300"
                  onClick={() => setTrainings([...trainings, {
                    name: "",
                    description: "",
                    duration: "",
                    zone: "",
                    repeatitions: 1,
                    um: "minutes"
                  }])}
                >
                  <MdAdd style={{ marginRight: "10px", }} /> Aggiungi nuovo esercizio

                </Button>

                <Button
                  mt="20px"
                  bg="blue.100"
                  onClick={() => handleOpenPrebuiltModal()}
                >
                  <MdAdd style={{ marginRight: "10px", }} /> Aggiungi esercizio esistente

                </Button>

              </FormControl>
            </form>
          </ModalBody>
          <ModalFooter>
            <Button onClick={onCloseEdit} mr={3}>Indietro</Button>
            <Button type="submit" colorScheme="green" onClick={handleSubmitEdit}>Modifica allenamento</Button>

          </ModalFooter>
        </ModalContent>
      </Modal>
      {/* END - FORM TO EDIT A NEW CATEGORY */}

      {/* BEGIN - FORM TO CREATE A NEW CATEGORY */}
      <Modal isOpen={isOpenCreate} onClose={onCloseEdit}>
        <ModalOverlay />
        <ModalContent
          minWidth="80%"
        >
          <ModalHeader>Crea un nuovo allenamento</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <form onSubmit={handleSubmit}>
              <FormControl id="categoryName">
                <Input
                  placeholder='Nome allenamento'
                  mb="20px"
                  type="text"
                  value={categoryName}
                  onChange={(event) => setCategoryName(event.target.value)}
                />


                {trainings.map((training, index) =>

                  <Box
                    borderWidth="3px"
                    borderColor="gray.400"
                    borderRadius="md"
                    p="5"
                    mb="20px"
                  >
                    <HStack
                      /* alignItems="center" */
                      justifyContent="space-between"
                      w="full"
                    >

                      <Box
                        fontSize="xl"
                        fontWeight="bold"
                        mb="10px"
                        bg="green.200"
                        w="30px"
                        h="30px"
                        borderRadius="50%"
                      >
                        <Center>
                          {index + 1}
                        </Center>
                      </Box>


                      <Center>
                        <Button
                          bg="red.500"
                          onClick={() => setTrainings([...trainings.slice(0, index), ...trainings.slice(index + 1)])}
                          p="5px"
                        >
                          <IoClose color="white" size="20px" />
                        </Button>

                      </Center>


                    </HStack>


                    <Flex
                      mt="10px"
                      alignItems="top"
                    >
                      <Input
                        type="text"
                        value={trainings[index].name}
                        onChange={(event) => setTrainings([...trainings.slice(0, index), { ...trainings[index], name: event.target.value }, ...trainings.slice(index + 1)])}
                        placeholder="Nome esercizio"
                        w="50%"
                        mr="20px"
                        onBlur={() => {
                          for (let i = 0; i < allexercises.length; i++) {
                            if (allexercises[i].name.toLowerCase().replaceAll(" ", "") === trainings[index].name.toLowerCase().replaceAll(" ", "")) {
                              setTrainings([...trainings.slice(0, index), { ...trainings[index], description: allexercises[i].description, duration: allexercises[i].duration, zone: allexercises[i].zone, repeatitions: allexercises[i].repeatitions, um: allexercises[i].um }, ...trainings.slice(index + 1)])
                              break;
                            }
                          }
                        }}
                        onKeyDown={
                          (e) => {
                            console.log("okok")

                            if (e.key === "Enter") {
                              for (let i = 0; i < allexercises.length; i++) {
                                if (allexercises[i].name.toLowerCase().replaceAll(" ", "") === trainings[index].name.toLowerCase().replaceAll(" ", "")) {
                                  setTrainings([...trainings.slice(0, index), { ...trainings[index], description: allexercises[i].description, duration: allexercises[i].duration, zone: allexercises[i].zone, repeatitions: allexercises[i].repeatitions, um: allexercises[i].um }, ...trainings.slice(index + 1)])
                                  break;
                                }
                              }

                            }
                          }
                        }
                      >
                      </Input>
                      <Textarea
                        type="text"
                        value={trainings[index].description}
                        onChange={(event) => setTrainings([...trainings.slice(0, index), { ...trainings[index], description: event.target.value }, ...trainings.slice(index + 1)])}
                        placeholder="Descrizione"
                        w="50%"
                        mr="20px"
                        rows={1}
                      >
                      </Textarea>





                    </Flex>

                    <Flex
                      mt="20px" Pforma
                      alignItems="center"

                    >
                      <Box mr="10px" ml="10px">
                        Tempo/distanza esercizio:
                      </Box>
                      <Input
                        type="text" //time?
                        value={trainings[index].duration}
                        onChange={(event) => setTrainings([...trainings.slice(0, index), { ...trainings[index], duration: event.target.value }, ...trainings.slice(index + 1)])}
                        w="300px"
                      >
                      </Input>
                      <Select
                        ml="20px"
                        w="200px"
                        value={trainings[index].um}
                        onChange={(event) => setTrainings([...trainings.slice(0, index), { ...trainings[index], um: event.target.value }, ...trainings.slice(index + 1)])} placeholder='Unità di misura'>
                        <option key="minutes" value="minutes">Minuti</option>
                        <option key="meters" value="meters">Metri</option>
                        <option key="meters" value="meters">Chilometri</option>

                      </Select>
                      <Select
                        ml="20px"
                        w="400px"
                        value={trainings[index].zone}
                        onChange={(event) => setTrainings([...trainings.slice(0, index), { ...trainings[index], zone: event.target.value }, ...trainings.slice(index + 1)])} placeholder='Seleziona una zona'>
                        <option key="z1" value="z1">Z1 - Recupero</option>
                        <option key="z2" value="z2">Z2 - Fondo lento</option>
                        <option key="z3" value="z3">Z3 - Fondo medio</option>
                        <option key="z4" value="z4">Z4 - Soglia</option>
                        <option key="z5" value="z5">Z5 - Vo2Max</option>
                        <option key="z6" value="z6">Z6 - Capacità anaerobica</option>
                        <option key="z7" value="z7">Z7 - Sprint</option>


                      </Select>

                    </Flex>
                    <Flex
                      mt="20px" Pforma
                      alignItems="center"

                    >
                      <Box mr="10px" ml="10px">
                        Tempo/distanza recupero:
                      </Box>
                      <Input
                        type="text" //time?
                        value={trainings[index].recovery}
                        onChange={(event) => setTrainings([...trainings.slice(0, index), { ...trainings[index], recovery: event.target.value }, ...trainings.slice(index + 1)])}
                        w="300px"
                      >
                      </Input>
                      <Select
                        ml="20px"
                        w="200px"
                        value={trainings[index].recovery_um}
                        onChange={(event) => setTrainings([...trainings.slice(0, index), { ...trainings[index], recovery_um: event.target.value }, ...trainings.slice(index + 1)])} placeholder='Unità di misura'>
                        <option key="minutes" value="minutes">Minuti</option>
                        <option key="meters" value="meters">Metri</option>
                        <option key="meters" value="meters">Chilometri</option>

                      </Select>
                      <Select
                        ml="20px"
                        w="400px"
                        value={trainings[index].recovery_zone}
                        onChange={(event) => setTrainings([...trainings.slice(0, index), { ...trainings[index], recovery_zone: event.target.value }, ...trainings.slice(index + 1)])} placeholder='Seleziona una zona'>
                        <option key="z1" value="z1">Z1 - Recupero</option>
                        <option key="z2" value="z2">Z2 - Fondo lento</option>
                        <option key="z3" value="z3">Z3 - Fondo medio</option>
                        <option key="z4" value="z4">Z4 - Soglia</option>
                        <option key="z5" value="z5">Z5 - Vo2Max</option>
                        <option key="z6" value="z6">Z6 - Capacità anaerobica</option>
                        <option key="z7" value="z7">Z7 - Sprint</option>


                      </Select>

                    </Flex>

                    <Flex
                      alignItems={"center"}
                      mt="20px"
                    >
                      <Box mr="10px" ml="10px">
                        Ripetizione/i:
                      </Box>

                      <NumberInput
                        w="100px"
                        min={1}
                        max={99}
                        defaultValue={1}
                        value={trainings[index].repeatitions}
                        onChange={(valueString, valueNumber) => {
                          setTrainings([...trainings.slice(0, index), { ...trainings[index], repeatitions: valueString ?? 1 }, ...trainings.slice(index + 1)])
                        }}
                      >
                        <NumberInputField />
                        <NumberInputStepper>
                          <NumberIncrementStepper />
                          <NumberDecrementStepper />
                        </NumberInputStepper>
                      </NumberInput>

                    </Flex>

                  </Box>
                )}

                <Button
                  mt="20px"
                  mr="20px"
                  bg="gray.300"
                  onClick={() => setTrainings([...trainings, {
                    name: "",
                    description: "",
                    duration: "",
                    zone: "",
                    repeatitions: 1,
                    um: "minutes"
                  }])}
                >
                  <MdAdd style={{ marginRight: "10px", }} /> Aggiungi nuovo esercizio

                </Button>

                <Button
                  mt="20px"
                  bg="blue.100"
                  onClick={() => handleOpenPrebuiltModal()}
                >
                  <MdAdd style={{ marginRight: "10px", }} /> Aggiungi esercizio esistente

                </Button>

              </FormControl>
            </form>
          </ModalBody>
          <ModalFooter>
            <Button onClick={onCloseCreate} mr={3}>Indietro</Button>
            <Button type="submit" colorScheme="green" onClick={handleSubmit}>Crea allenamento</Button>

          </ModalFooter>
        </ModalContent>
      </Modal>
      {/* END - FORM TO CREATE A NEW CATEGORY */}

      {/* BEGIN - BACK BUTTON */}
      {/* <Stack mt="5" ml="2" mb="5" mr="15" direction='row' spacing={4}>
        <Center><IconButton
          isRound={true}
          variant='solid'
          colorScheme='teal'
          aria-label='Done'
          fontSize='20px'
          icon={<IoMdArrowRoundBack />}
        /></Center>
        <Box w="5%"></Box>
        <Center >
          <Text
            fontSize="4xl"
            as="b"
            color="teal">
            {commonContext.currentPath}
          </Text>
        </Center>
      </Stack> */}
      {/* END - BACK BUTTON */}

      <hr></hr>

      {/* BEGIN - TOP ROW */}
      <Stack pr="20px" mt="2%" ml="2" mb="10" direction='row' spacing={4} justifyContent="space-between">
        <Flex justifyContent="left" w="100%" >
          <Button mr="20px" leftIcon={<MdAdd />} colorScheme='green' variant='solid' onClick={() => {navigate("/newtrainingsheet")}}>
            Nuova scheda
          </Button>
          {/* <Link to="/sortCategories">
            <Button leftIcon={<BsSortUp />} colorScheme='orange' variant='solid' >
              Modifica ordine
            </Button>
          </Link> */}
        </Flex>
        <Flex justifyContent="right" w="100%" >
          {/*  <Input
            mr="20px"
            borderColor="black"
            w="20%"
            placeholder="Cerca categoria padre..."
            type="text"
            value={searchFather}
            onChange={(event) => {
              setSearchFather(event.target.value)
              setTableContent(allData.filter((item) => item.fatherName.toLowerCase().includes(event.target.value.toLowerCase()) && item.name.toLowerCase().includes(search.toLowerCase())))
            }}
          /> */}
          <Input
            borderColor="black"
            w="35%"
            placeholder="Cerca scheda..."
            type="text"
            value={search}
            onChange={(event) => {
              setSearch(event.target.value)
              setTableContent(allData.filter((item) => item.name.toLowerCase().includes(event.target.value.toLowerCase())))
            }}
          />
        </Flex>
      </Stack>
      {/* END - TOP ROW */}

      {/* BEGIN - DELETE FROM */}
      <AlertDialog
        isOpen={isOpenDelete}
        onClose={onCloseDelete}
      >
        <AlertDialogOverlay>
          <AlertDialogContent>
            <AlertDialogHeader fontSize='lg' fontWeight='bold'>
              Elimina esercizio
            </AlertDialogHeader>

            <AlertDialogBody>
              Vuoi eliminare definitivamente la scheda "{nameToDelete}"?
            </AlertDialogBody>

            <AlertDialogFooter>
              <Button onClick={onCloseDelete}>
                Indietro
              </Button>
              <Button colorScheme='red' onClick={deleteSheet} ml={3}>
                Elimina
              </Button>
            </AlertDialogFooter>
          </AlertDialogContent>
        </AlertDialogOverlay>
      </AlertDialog>
      {/* END - DELETE FORM */}
      {allData.length < 1 && <Flex h="300px" alignItems="center" justifyContent="center">
        <Text fontSize="xl" as="b" color="teal">Nessun allenamento</Text>
      </Flex>}
      {/* BEGIN - TABLE */}
      {allData.length > 0 && <TableContainer h="100%" >
        <Table variant='striped' colorScheme='blue' w="100%" sx={{ tableLayout: "fixed" }}>
          {/* <TableCaption>Elenco delle categorie</TableCaption> */}
          <Thead>
            <Tr>
              <Th w="5%">ID</Th>
              <Th   _hover={{ cursor: "pointer" }} onClick={handleSortName}><Flex align="center" >Nome{sortedBy === "name" && sortOrder === "asc" && <FaSortDown />} {sortedBy === "name" && sortOrder === "desc" && <FaSortUp />}</Flex></Th>
              <Th _hover={{ cursor: "pointer" }} onClick={handleSortCreated} w="15%"><Flex align="center">Creata il {sortedBy === "created" && sortOrder === "asc" && <FaSortDown />} {sortedBy === "created" && sortOrder === "desc" && <FaSortUp />}</Flex></Th>
              <Th w="15%"></Th>
            </Tr>
          </Thead>
          <Tbody>
            {tableContent.map((item) => (
              <Tr key={item.id}>
                <Td>{item.id}</Td>
                <Td title={item.name} overflowX="hidden" overflow="hidden" textOverflow="ellipsis" whiteSpace="normal">{item.name}</Td>
                <Td>{item.created_at}</Td>
                <Td>
                  {/* <IconButton
                    mr="2"
                    colorScheme='green'
                    aria-label='Call Segun'
                    size='sm'
                    icon={<FaCopy />}
                    onClick={() => {
                      openCopy(item.name, item.trainings)
                    }}
                  /> */}
                  <IconButton
                    mr="2"
                    colorScheme='orange'
                    aria-label='Call Segun'
                    size='sm'
                    icon={<MdEdit />}
                    onClick={() => {
                      navigate("/edittrainingsheet", { state: {
                        item: item
                      } })
                    }}
                  />
                  <IconButton
                    mr="2"
                    colorScheme='red'
                    aria-label='Call Segun'
                    size='sm'
                    icon={<MdDelete />}
                    onClick={() => { openDelete(item.id, item.name) }}
                  />
                </Td>

              </Tr>
            ))}

          </Tbody>
          <Tfoot>
            <Tr>
              <Th w="5%">ID</Th>
              <Th  _hover={{ cursor: "pointer" }} onClick={handleSortName}><Flex align="center" >Nome{sortedBy === "name" && sortOrder === "asc" && <FaSortDown />} {sortedBy === "name" && sortOrder === "desc" && <FaSortUp />}</Flex></Th>
              <Th  _hover={{ cursor: "pointer" }} onClick={handleSortCreated} w="15%"><Flex align="center">Creata il {sortedBy === "created" && sortOrder === "asc" && <FaSortDown />} {sortedBy === "created" && sortOrder === "desc" && <FaSortUp />}</Flex></Th>
              <Th w="15%"></Th>
            </Tr>

          </Tfoot>
        </Table>
      </TableContainer>}


      <Center w="100%" mb="4">
        <IconButton
          isRound={true}
          variant='solid'
          colorScheme='teal'
          aria-label='Done'
          fontSize='20px'
          onClick={() => {
            if (page > 1) {
              setTableContent(allData.slice((page * 7) - 14, (page * 7) - 7));
              setPage(page - 1);
            }
          }}
          icon={<AiFillStepBackward />}
        />
        <Text ml="4" mr="4">
          {page} / {Math.ceil(allData.length / 7)}
        </Text>
        <IconButton
          isRound={true}
          variant='solid'
          colorScheme='teal'
          aria-label='Done'
          fontSize='20px'
          onClick={() => {
            if (page < Math.ceil(allData.length / 7)) {
              setTableContent(allData.slice((page * 7), (page * 7) + 7));
              setPage(page + 1);
            }
          }}
          icon={<AiFillStepForward />}
        />
      </Center>

      {/* END - TABLE */}
    </div>

  );

}

export default TrainingSheets;